import React, { useEffect, useRef, useState } from 'react';

let ffmpeg; //Store the ffmpeg instance

const useVideoTrim = (): any => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    //Created to load script by passing the required script and append in head tag
    const loadScript = (src) => {
        return new Promise((onFulfilled, _) => {
            const script: any = document.createElement('script');
            let loaded;
            script.async = 'async';
            script.defer = 'defer';
            script.setAttribute('src', src);
            script.onreadystatechange = script.onload = () => {
                if (!loaded) {
                    onFulfilled(script);
                }
                loaded = true;
            };
            script.onerror = function () {
                console.error('Script failed to load');
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    };

    //Handle Upload of the video


    //Convert the time obtained from the video to HH:MM:SS format
    const convertToHHMMSS = (val) => {
        const secNum = parseInt(val, 10);
        let hours: any = Math.floor(secNum / 3600);
        let minutes: any = Math.floor((secNum - hours * 3600) / 60);
        let seconds: any = secNum - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = '0' + hours;
        }
        if (minutes < 10) {
            minutes = '0' + minutes;
        }
        if (seconds < 10) {
            seconds = '0' + seconds;
        }
        let time;
        // only mm:ss
        if (hours === '00') {
            time = minutes + ':' + seconds;
        } else {
            time = hours + ':' + minutes + ':' + seconds;
        }
        return time;
    };

    useEffect(() => {
        //Load the ffmpeg script

    }, []);


    const blobToDataURL = (blob) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };
    //Called when handle of the nouislider is being dragged

    const getFramesV2 = async (recorded: any) => {
        let ffmpegInstance
        let frames = [];
        try {
            let isScriptLoaded2 = false

            await loadScript(
                'https://cdn.jsdelivr.net/npm/@ffmpeg/ffmpeg@0.11.2/dist/ffmpeg.min.js',
            )
            if (typeof window !== 'undefined') {
                ffmpegInstance = window.FFmpeg.createFFmpeg({ log: true });
                await ffmpegInstance.load();
                isScriptLoaded2 = true;
            }
            if (!recorded) return;

            if (isScriptLoaded2 && !ffmpegInstance.isLoaded()) {
                await ffmpegInstance.load();
            }



            const randomId = Math.floor(Math.random() * 999999);
            const dirName = `thumbnails-${randomId}`;
            const filename = `input${randomId}.mp4`;

            // Write video to virtual FS
            const videoData = new Uint8Array(await recorded.video.arrayBuffer());
            ffmpegInstance.FS('writeFile', filename, videoData);

            // Create directory for frames
            ffmpegInstance.FS('mkdir', dirName);

            // Extract frames
            await ffmpegInstance.run(
                "-ss", "1",
                "-i", filename,
                "-r", "1",
                "-f", "image2",
                "-vf", "fps=1,scale=320:-1",
                "-q:v", "2",
                "-preset", "ultrafast",
                `${dirName}/%04d.png`
            );

            // Read frames from directory

            let index = 1;
            while (true) {
                const fileName = `${dirName}/${index.toString().padStart(4, '0')}.png`;
                try {
                    const data = ffmpegInstance.FS('readFile', fileName);
                    const blob = new Blob([data.buffer], { type: 'image/png' });
                    const frame = await blobToDataURL(blob);
                    frames.push(frame);
                    index++;
                } catch (e) {
                    break; // No more frames
                }
            }
            try {
                // Cleanup
                const files = ffmpegInstance.FS('readdir', '/');
                if (files.includes(filename)) {
                    ffmpegInstance.FS('unlink', filename);

                    for (let i = 1; i < index; i++) {
                        const fileName = `${dirName}/${i.toString().padStart(4, '0')}.png`;
                        ffmpegInstance.FS('unlink', fileName);
                    }
                    ffmpegInstance.FS('rmdir', dirName);
                } else {
                    console.warn(`File ${filename} not found in FS.`);
                }


            } catch (error: any) {
                console.error(error)
            }



        } catch (error) {
            console.error('Error extracting frames:', error);
        } finally {
            ffmpegInstance?.exit();
        }
        return frames
    };


    //Trim functionality of the video
    const handleTrimVideo = async (videoFileValue, startTime, endTime) => {
        let ffmpegInstance
        let response
        try {
            let isScriptLoaded2 = false

            await loadScript(
                'https://cdn.jsdelivr.net/npm/@ffmpeg/ffmpeg@0.11.2/dist/ffmpeg.min.js',
            )
            if (typeof window !== 'undefined') {
                ffmpegInstance = window.FFmpeg.createFFmpeg({ log: true });
                await ffmpegInstance.load();
                isScriptLoaded2 = true;
            }
            if (!videoFileValue.video) return;
            const { type, } = videoFileValue.video;
            if (isScriptLoaded2 && !ffmpegInstance.isLoaded()) {
                await ffmpegInstance.load();
            }
            ffmpegInstance.FS(
                'writeFile',
                "edited.mp4",
                new Uint8Array(await videoFileValue.video.arrayBuffer()),
            );
            const videoFileType = type.split('/')[1];
            //Run the ffmpeg command to trim video
            await ffmpegInstance.run(
                '-ss', `${convertToHHMMSS(startTime)}`,
                '-to', `${convertToHHMMSS(endTime)}`,
                '-i', `edited.${videoFileType}`,
                '-acodec', 'copy',
                '-vcodec', 'copy',
                `out.webm`,
            );
            //Convert data to url and store in videoTrimmedUrl state
            const outputData = ffmpegInstance.FS('readFile', `out.webm`);
            const videoBlob = new Blob([outputData.buffer], { type: `video/${videoFileType}` });
            //const videoURL = URL.createObjectURL(videoBlob);
            response= videoBlob
            //return null
        } catch (error: any) {
            console.error(error)
        }finally{
            ffmpegInstance?.exit()
        }
        return response
    
};

return { isScriptLoaded, handleTrimVideo, getFramesV2 };
}

export default useVideoTrim;